/**
 * Canonical origin for the site.
 *
 * Used by metadataBase, the sitemap and JSON-LD, all of which need absolute
 * URLs. Vercel exposes the production domain, but only for the production
 * environment -- preview deployments would otherwise emit canonicals pointing
 * at themselves, so this falls back to the real domain rather than to
 * VERCEL_URL.
 *
 * www, not the apex. Vercel serves this site from www and 308s the apex to
 * it, so an apex origin here made every canonical, og:url, og:image and
 * sitemap entry point at a URL that immediately redirects -- which invites
 * www/apex indexing ambiguity, and breaks the share card outright on the
 * scrapers that decline to follow redirects for images.
 *
 * If the primary domain ever changes, change it here rather than reaching for
 * VITE_SITE_URL: that override is inlined at build time, so it only takes
 * effect on a rebuild and is easy to forget on a fresh environment.
 */
export const SITE_URL =
  import.meta.env.VITE_SITE_URL ?? 'https://www.butterwebsites.com';
